import "./spangles-color-guide.scss";
import "./color-block/color-block.scss";

const $spanglesColorGuide = document.querySelector(".spangles-color-guide");

const initSpanglesColorGuide = () => {
  const $header = $spanglesColorGuide.querySelector(".spangles-color-guide-header");
  $header.addEventListener("click", () => {
    $header.classList.toggle("active");

    const panel = $header.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
};

export default initSpanglesColorGuide;
